export default "__VITE_ASSET__Bb4JX8xL__"